import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const MarketContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 6px;
`;

// Height override needed because SearchEngineLanguagePicker's DropdownButton
// doesn't expose a height prop; this aligns it with the 40px LocationPicker button.
export const LanguagePickerWrapper = styled.div`
    .DropdownButton {
        height: 40px;
    }
`;

